/* app/js/src/components/graphics/edit/fields/media-item.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.media-container {
  width: 155px;
  height: 115px;
  font-size: 13px;
  color: #949fa3;
  background-color: #ffffff;
  border: dashed 1px #c6d2df;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.media-container.on-drag > * {
  pointer-events: none;
}
.media-container.media {
  border: solid 1px #c6d2df;
  background-size: 155px 115px;
}
.media-container.dynamic {
  justify-content: center;
  font-size: 12px;
  color: #232f3a;
}
.media-container.dynamic div {
  flex-grow: 0.1;
}
.media-container.link img {
  width: 155px;
  height: 115px;
}
.media-container .plus-sign {
  width: 35px;
  height: 35px;
  margin-top: 34px;
}
.media-container .plus-sign ::ng-deep svg path {
  fill: #c6d2df;
}
.media-container .inner-text {
  line-height: 13px;
  margin-top: 15px;
}
.media-container:hover,
.media-container.on-drag {
  border-color: #a65bfa;
}
.media-container:hover .plus-sign ::ng-deep svg path,
.media-container.on-drag .plus-sign ::ng-deep svg path {
  fill: #a65bfa;
}
.media-container:hover .inner-text,
.media-container.on-drag .inner-text {
  color: #a65bfa;
}
.media-container:hover .x-sign,
.media-container.on-drag .x-sign {
  background-color: #232f3a;
}
.media-container:hover .x-sign ::ng-deep svg path,
.media-container.on-drag .x-sign ::ng-deep svg path {
  fill: #ffffff;
}
.media-container:hover .hover-menu {
  opacity: 1;
  background-color: rgba(35, 47, 58, 0.5);
  pointer-events: auto;
  cursor: pointer;
}
.media-container:hover .hover-menu .icon:hover ::ng-deep svg path {
  fill: #a65bfa !important;
}
.media-container:hover .hover-menu .icon:hover ::ng-deep svg g rect {
  fill: #a65bfa !important;
}
.media-container:hover .hover-menu .icon:hover ::ng-deep svg g polygon {
  fill: #a65bfa !important;
}
.media-container:hover .description-icon {
  opacity: 0;
}
.x-sign {
  position: absolute;
  right: -10.5px;
  top: -10.5px;
  background-color: #eef2f6;
  border-radius: 50%;
  width: 21px;
  height: 21px;
  text-align: center;
  padding-top: 4px;
  cursor: pointer;
}
.hover-menu {
  position: absolute;
  background-color: rgba(35, 47, 58, 0);
  opacity: 0;
  width: 155px;
  height: 115px;
  display: flex;
  align-items: center;
  pointer-events: none;
}
.hover-menu .icon {
  width: 35px;
  height: 35px;
  background-color: white;
  border-radius: 50%;
  padding-top: 11.7px;
  text-align: center;
  cursor: pointer;
}
.hover-menu .icon.first {
  margin-left: 38px;
}
.hover-menu .icon.second {
  margin-left: 10px;
}
.description-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(35, 47, 58, 0.65);
  position: absolute;
  bottom: 5px;
  left: 8px;
}
.description-icon.video {
  background: rgba(35, 47, 58, 0.65) url(/assets/icons/vid-icon.png) no-repeat center;
}
.description-icon ::ng-deep svg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.description-icon ::ng-deep svg path {
  fill: #ffffff;
}
.media-label {
  width: 155px;
  height: 12px;
  margin-top: 16px;
  font-size: 12px;
  line-height: 12px;
  color: #7d8fa1;
  text-align: center;
}
:host(.is-current) .media-container {
  border-style: solid;
  border-color: #232f3a;
}
:host(.is-current) .media-container .x-sign {
  background-color: #232f3a;
}
:host(.is-current) .media-container .x-sign ::ng-deep svg path {
  fill: #ffffff;
}
:host(.is-current) .media-label {
  color: #232f3a;
}
/*# sourceMappingURL=media-item.component.css.map */
